// extracted by mini-css-extract-plugin
export default {"autocomplete":"style_autocomplete__Yrr6u"};